(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-commercial-landing"]) return;
  try {
    
  (function() {
    if (window.fmbCommercialModalReady) {
      return;
    }

    window.fmbCommercialModalReady = true;

    function openModal(id) {
      var modal = document.getElementById(id);

      if (!modal) {
        return;
      }

      if (typeof modal.showModal === 'function') {
        modal.showModal();
        return;
      }

      modal.setAttribute('open', '');
    }

    function closeModal(modal) {
      if (!modal) {
        return;
      }

      if (typeof modal.close === 'function' && modal.open) {
        modal.close();
        return;
      }

      modal.removeAttribute('open');
    }

    document.addEventListener('click', function(event) {
      var trigger = event.target.closest('[data-commercial-modal-open]');
      var closeButton = event.target.closest('[data-commercial-modal-close]');

      if (trigger) {
        openModal(trigger.getAttribute('data-commercial-modal-open'));
        return;
      }

      if (closeButton) {
        closeModal(closeButton.closest('[data-commercial-modal]'));
        return;
      }

      if (event.target.matches('[data-commercial-modal]')) {
        closeModal(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
